import React, { Component } from "react";
import uuid from "react-uuid";
import { toast } from "react-toastify";
import Loading from "../../../common/components/loading/loading";
import DualListBox from "../../../common/components/form/dualListBox";
import { getMarkets } from "../../../common/services/markets/marketService";
import {
  getMarketControl,
  insertOrUpdateMarketControl,
} from "../../../common/services/tradingEngine/marketStateService";
import { withTranslation } from "react-i18next";

class OrganizationTradingMarkets extends Component {
  state = {
    options: [],
    selected: [],
    marketControls: [],
    isLoading: true,
  };

  async componentDidMount() {
    await this.loadData();
  }

  async componentDidUpdate(previousProps) {
    if (previousProps.organizationId !== this.props.organizationId) {
      await this.loadData();
    }
  }

  async loadData() {
    const { organizationId } = this.props;
    const [markets, marketControls] = await Promise.all([
      getMarkets(),
      getMarketControl(),
    ]);

    const marketNameById = new Map(
      markets.map((market) => [
        market.marketId,
        market.name || market.marketId,
      ]),
    );
    const tradingMarkets = marketControls
      .filter((marketControl) => marketNameById.has(marketControl.marketId))
      .sort((left, right) =>
        (marketNameById.get(left.marketId) || left.marketId).localeCompare(
          marketNameById.get(right.marketId) || right.marketId,
        ),
      );

    this.setState({
      options: tradingMarkets.map((marketControl) => ({
        value: marketControl.marketId,
        label:
          marketNameById.get(marketControl.marketId) || marketControl.marketId,
      })),
      selected: tradingMarkets
        .filter((marketControl) =>
          (marketControl.organizationIds || []).includes(organizationId),
        )
        .map((marketControl) => marketControl.marketId),
      marketControls: tradingMarkets,
      isLoading: false,
    });
  }

  async handleChange(selected, selection, controlKey) {
    const { organizationId, t } = this.props;

    if (controlKey !== "available" && controlKey !== "selected") {
      toast.warning(t("UnexpectedError"));
      return null;
    }

    this.setState({ selected });

    const nextSelected = [...selected];
    const nextMarketControls = [...this.state.marketControls];

    for (const marketId of selection) {
      const marketIndex = nextMarketControls.findIndex(
        (marketControl) => marketControl.marketId === marketId,
      );
      if (marketIndex < 0) {
        continue;
      }

      const marketControl = nextMarketControls[marketIndex];
      const organizationIds = new Set(marketControl.organizationIds || []);

      if (controlKey === "available") {
        organizationIds.add(organizationId);
      } else {
        organizationIds.delete(organizationId);
      }

      try {
        const updatedMarketControl = await insertOrUpdateMarketControl({
          ...marketControl,
          organizationIds: Array.from(organizationIds),
          eventId: uuid(),
        });
        nextMarketControls[marketIndex] = updatedMarketControl;
        toast.success(t("TradingMarketOrganizationsUpdated", { ns: "trading" }));
      } catch (ex) {
        console.log(ex);

        if (controlKey === "available") {
          const selectedIndex = nextSelected.indexOf(marketId);
          if (selectedIndex > -1) {
            nextSelected.splice(selectedIndex, 1);
          }
        } else {
          nextSelected.push(marketId);
        }

        toast.error(t("TradingMarketOrganizationsUpdateFailed", { ns: "trading" }));
      }
    }

    this.setState({
      selected: Array.from(new Set(nextSelected)),
      marketControls: nextMarketControls,
    });
  }

  render() {
    const { options, selected, isLoading } = this.state;
    const { allowEdit, t } = this.props;

    if (isLoading) return <Loading />;

    return (
      <div>
        <DualListBox
          canFilter
          className="rdl-hide-move-all"
          disabled={!allowEdit}
          options={options}
          selected={selected}
          onChange={(nextSelected, selection, controlKey) =>
            this.handleChange(nextSelected, selection, controlKey)
          }
        />
        <small className="form-text text-muted">
          {t("OrganizationTradingMarketsHelpText", { ns: "trading" })}
        </small>
      </div>
    );
  }
}

export default withTranslation(["auth", "trading"])(OrganizationTradingMarkets);


